import { useDate } from './useDate';
export function usePanel(part) {
  var date = useDate();
  return date.getPanel(part);
}